import { render, staticRenderFns } from "./SuccessBuyDomain.vue?vue&type=template&id=79408532&scoped=true"
import script from "./SuccessBuyDomain.vue?vue&type=script&lang=js"
export * from "./SuccessBuyDomain.vue?vue&type=script&lang=js"
import style0 from "./SuccessBuyDomain.vue?vue&type=style&index=0&id=79408532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79408532",
  null
  
)

export default component.exports